/*  CELLS · SETAS E BOLINHAS DA GALERIA DA PDP  (22/09/2026)
    ------------------------------------------------------------------
    Porta para a PDP o comportamento da galeria da Semana do Cliente:
    setas sempre visiveis nas bordas da foto e bolinhas de posicao no
    rodape dela, no lugar do contador "1 / 12" do tema.

    DOIS MODOS, PORQUE A GALERIA DO TEMA TEM DOIS

    - Celular: a lista rola de verdade. O botao do tema ja faz o
      trabalho; aqui so sincronizamos as bolinhas e o estado desativado
      nas pontas.

    - Desktop (layout "thumbnail"): as fotos nao ativas ficam em
      display:none e a troca acontece clicando na miniatura. O botao do
      tema rolaria uma lista que nao rola, entao o clique e
      interceptado e passa a chamar setActiveMedia — o mesmo caminho da
      miniatura.

    O listener e de CAPTURA com stopImmediatePropagation: o handler do
    <slider-component> esta no MESMO botao, e so parar a propagacao o
    deixaria rodar e quebrar em global.js (lista sem itens visiveis).
    ------------------------------------------------------------------ */
(function () {
  var MQ = window.matchMedia('(min-width: 750px)');

  // So os slides do visor: dentro de cada <li> ha outro elemento com
  // data-media-id (o abridor do modal), e contar os dois dobrava as bolinhas.
  function itensDe(visor) {
    return Array.prototype.slice.call(visor.querySelectorAll('.product__media-list > [data-media-id]'));
  }

  function indiceAtivo(visor, itens) {
    var lista = visor.querySelector('.product__media-list');

    /*  QUEM ROLA MANDA — e esta ordem importa.

        Antes o `is-active` era consultado PRIMEIRO e, achado, a funcao
        retornava ali mesmo. No desktop isso esta certo: as fotos nao
        ativas ficam em display:none e o `is-active` e a unica verdade.

        No celular era um bug silencioso. A lista rola de verdade, mas o
        `is-active` do tema so se move quando alguem chama
        setActiveMedia — clicar na miniatura, trocar de variante. Passar
        o dedo ou clicar na seta nao chamam. Entao ele ficava colado no
        slide 0 para sempre, o calculo por centro nunca rodava, e o
        retorno era 0 em qualquer posicao.

        Custava duas coisas visiveis: a seta da esquerda nascia
        desabilitada (`atual === 0`) e nunca destravava, e a bolinha
        acesa nunca saia da primeira por mais que a pessoa avancasse.

        Com a rolagem consultada primeiro, o desktop nao muda: la a
        lista nao rola (scrollWidth == clientWidth, so um slide visivel)
        e a condicao cai direto no `is-active`. */
    if (lista && lista.scrollWidth > lista.clientWidth + 1) {
      var centro = lista.scrollLeft + lista.clientWidth / 2;
      var melhor = 0;
      var menorDistancia = Infinity;
      itens.forEach(function (item, i) {
        var meio = item.offsetLeft + item.offsetWidth / 2;
        var distancia = Math.abs(meio - centro);
        if (distancia < menorDistancia) {
          menorDistancia = distancia;
          melhor = i;
        }
      });
      return melhor;
    }

    var ativo = itens.findIndex(function (item) {
      return item.classList.contains('is-active');
    });
    return ativo === -1 ? 0 : ativo;
  }

  function ligar(galeria) {
    var visor = galeria.querySelector('[id^="GalleryViewer"]');
    if (!visor || galeria.dataset.cellsGaleria === '1') return;

    var itens = itensDe(visor);
    if (itens.length < 2) return;
    galeria.dataset.cellsGaleria = '1';

    var botoes = Array.prototype.slice.call(visor.querySelectorAll('.slider-button'));
    var lista = visor.querySelector('.product__media-list');
    var desktopPorMiniatura = (galeria.dataset.desktopLayout || '').indexOf('thumbnail') !== -1;

    // ---------- bolinhas ----------
    var dots = document.createElement('div');
    dots.className = 'cells-galeria-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Fotos do produto');
    itens.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Foto ' + (i + 1) + ' de ' + itens.length);
      b.addEventListener('click', function () {
        irPara(i);
      });
      dots.appendChild(b);
    });
    visor.appendChild(dots);

    function sincronizar() {
      var atuais = itensDe(visor);
      var atual = indiceAtivo(visor, atuais);
      Array.prototype.forEach.call(dots.children, function (b, i) {
        b.classList.toggle('is-sel', i === atual);
        b.setAttribute('aria-selected', i === atual ? 'true' : 'false');
      });
      botoes.forEach(function (botao) {
        botao.disabled = botao.name === 'previous' ? atual === 0 : atual === atuais.length - 1;
      });
    }

    function irPara(i) {
      var atuais = itensDe(visor);
      var alvo = atuais[Math.max(0, Math.min(i, atuais.length - 1))];
      if (!alvo) return;
      if (MQ.matches && desktopPorMiniatura) {
        galeria.setActiveMedia(alvo.dataset.mediaId, false);
      } else if (lista) {
        lista.scrollTo({ left: alvo.offsetLeft, behavior: 'smooth' });
      }
      window.setTimeout(sincronizar, 350);
    }

    // ---------- setas ----------
    botoes.forEach(function (botao) {
      botao.addEventListener(
        'click',
        function (evento) {
          if (!MQ.matches || !desktopPorMiniatura) return; // celular: rolagem nativa do tema
          evento.preventDefault();
          evento.stopImmediatePropagation();
          irPara(indiceAtivo(visor, itensDe(visor)) + (botao.name === 'previous' ? -1 : 1));
        },
        true,
      );
      botao.addEventListener('click', function () {
        window.setTimeout(sincronizar, 350);
      });
    });

    if (lista) {
      lista.addEventListener(
        'scroll',
        function () {
          window.clearTimeout(lista.__cellsTimer);
          lista.__cellsTimer = window.setTimeout(sincronizar, 90);
        },
        { passive: true },
      );
    }

    visor.addEventListener('slideChanged', sincronizar);
    MQ.addEventListener('change', sincronizar);
    sincronizar();
  }

  function varrer() {
    document.querySelectorAll('media-gallery').forEach(ligar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', varrer);
  } else {
    varrer();
  }

  // A troca de variante redesenha a galeria (product-info.js).
  document.addEventListener('shopify:section:load', varrer);
  window.addEventListener('pageshow', varrer);
  new MutationObserver(varrer).observe(document.documentElement, { childList: true, subtree: true });
})();
